<template>
  <div class="l-checkbox" :style="computedHeightStyle">
    <el-checkbox v-if="onlyselect && readonly" onclick="return false"  v-model="value3" :disabled="disabled" :size="size"
      :true-label="useNumber?1:true"
    :false-label="useNumber?0:false">
  </el-checkbox>
    <el-checkbox v-else-if="onlyselect"  v-model="value3" :disabled="disabled" :size="size"
      :true-label="useNumber?1:true"
    :false-label="useNumber?0:false">
  </el-checkbox>
    <el-checkbox-group v-else v-model="value2"  class="checkbox-group-wrap">
      <template v-for="(item,index) in options" >
          <el-checkbox :disabled="disabled" :size="size" :key="index" :label="item[valueKey]">{{item[labelKey]}}</el-checkbox>
      </template>
    </el-checkbox-group>
  </div>
</template>
<script>


export default {
  name:'l-checkbox',
  props: {
      value:{},
      labelKey:{
          type:String,
          default:'label'
      },
      valueKey:{
          type:String,
          default:'value'
      },
      readonly:{
        type:Boolean,
        default:false,
      },
      useNumber:Boolean,
      onlyselect:{
        type:Boolean,
        default:false,
      },
      options:{
          type:Array,
          default:()=>[]
      },
      rows:{
        type: [String,Number],
        default:"1"
      },
      disabled:Boolean,
      size: String,
  },
  data () {
    return {
    };
  },
  computed:{
    computedHeightStyle() {
      // 仅在多选模式且rows>1时设置固定高度
      if (!this.onlyselect && this.rows > 1) {
        return { height: `${this.rows * 30}px` };
      }
      return {};
    },
    value2:{
      get(){
        if(!this.$validatenull(this.value)){
          return (this.value + '').split(',');
        }
        else{
          return [];
        }
      },
      set(val){
        this.$emit('input', String(val))

        const objs = []
        if(val.length == 0){
          this.$emit('change', undefined)
        }
        else{
          val.forEach(item => {
            const objone = this.options.find(t=>t[this.valueKey] == item)
            objs.push(objone)
          })
          this.$emit('change', objs)
        }
      }
    },
    value3:{
      get(){
        if(!this.$validatenull(this.value)){
          if(this.useNumber){
            return this.value ==1;
          }else{
            return this.value;
          }
        }
        else{
          return this.useNumber?0:false;
        }
      },
      set(val){
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  methods:{
  }

}
</script>
<style lang="less">
@import './index.less';
</style>
